import styled, { css } from 'styled-components';

export const ComparePlansCardDetailStyled = styled.div.attrs(() => ({
  className: 'card-plan',
}))`
  ${({ theme, selected, badge }) => {
    const { fonts, media, colors } = theme;
    return css`
      &.card-plan {
        font-family: ${fonts.objectSans};
        display: flex;
        flex: 1;
        padding: ${badge ? '16px 16px 16px 16px' : '32px 16px 16px 16px'};
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
        border-radius: 32px;
        border: ${selected ? `1px solid ${colors.primary.neutralLight}` : '0'};
        background: ${colors.primary.white};
        box-shadow: ${selected ? '0 1px 2px 0 rgba(33, 33, 33, 0.12)' : 'none'};
        ${media.mobile.down} {
          padding: ${badge ? '16px 8px 8px 8px' : '28px 8px 8px 8px'};
        }
        ${media.tablet.up} {
          flex: 1 1 32%;
          max-width: 32%;
          box-sizing: border-box;
        }
        .plan-badge {
          display: flex;
          padding: 8px;
          justify-content: center;
          align-items: center;
          gap: 8px;
          border-radius: 4px;
          span {
            font-family: ${fonts.objectSans};
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 18px;
          }
          ${media.mobile.down} {
            span {
              font-size: 10px;
              line-height: 14px;
            }
          }
        }
        .best-badge {
          color: ${colors.primary.gravity};
          background-color: ${colors.primary.celeste};
        }
        .fast-badge {
          color: ${colors.primary.celeste};
          background-color: ${colors.primary.gravity};
        }
        h4 {
          color: ${colors.primary.gravity};
        }
        .plan-details {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          flex: 1 0 0;
          align-self: stretch;
          .plan-price {
            display: flex;
            align-items: flex-end;
            gap: 2px;
            align-self: stretch;
            h4 {
              font-size: 30px;
              font-style: normal;
              font-weight: 700;
              line-height: 34px;
              ${media.mobile.down} {
                font-size: 20px;
                line-height: 24px;
              }
            }
            .helper-text {
              display: flex;
              align-items: flex-start;
              gap: 8px;
              align-self: stretch;
            }
            span {
              display: flex;
              align-items: flex-start;
              gap: 8px;
              align-self: stretch;
            }
          }
          span {
            color: ${colors.primary.neutral};
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
            ${media.mobile.down} {
              font-size: 10px;
              line-height: 14px;
            }
          }
        }
        .plan-name {
          display: flex;
          align-items: flex-end;
          gap: 2px;
          align-self: stretch;
          h4 {
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: 28px;
            ${media.mobile.down} {
              font-size: 16px;
              line-height: 20px;
            }
          }
        }
        .btn-select-plan-compare {
          display: flex;
          align-items: flex-start;
          ${media.desktop.up} {
            max-width: 33%;
          }
          ${media.tablet.down} {
            max-width: 60%;
          }
          button {
            display: flex;
            padding: var(--padding-padding-sm, 8px) var(--padding-padding-2xl, 32px);
            justify-content: center;
            align-items: center;
            gap: var(--spacing-spacing-sm, 8px);
          }
        }
      }
    `;
  }}
`;
export default ComparePlansCardDetailStyled;
